import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LongTermCareInsuranceStep(): ReactElement {
  const dispatch = useDispatch();
  const { longTermCareInsurancePossessed: longTermCareInsurancePossessed } =
    useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('have_ltc_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Long-Term Care Insurance"
          subHeader=" Long-term care insurance pays for nursing homes, assisted living
          facilities and in-home care."
        />
      </GrayCard>

      <CardPadding>
        <CardHeader header="Do you have long-term care insurance?" />
        <Formik
          initialValues={{ longTermCareInsurancePossessed }}
          onSubmit={onSubmit}
          validationSchema={createYesNoObjectSchema(
            'longTermCareInsurancePossessed'
          )}
        >
          <Form ref={formRef}>
            <YesOrNoStepCreator name="longTermCareInsurancePossessed" />

            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { LongTermCareInsuranceStep };
